import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Propertylist.css";

const Propertylist = () => {
  const [properties, setProperties] = useState([]);

  const handleDelete = (id) => {
    const filtered = properties.filter(property => property.id !== id);
    setProperties(filtered);
  };

  useEffect(() => {
    axios
      .get("http://104.214.177.15:8080/api/Property/GetProperties")
      .then((res) => setProperties(res.data))
      .catch((err) => console.error("Error fetching properties:", err));
  }, []);

  return (
    <div className="property-list">
    {properties.map(property => (
      <div key={property.id} className="property-card">
        <img src={property.image} alt="Property" className="property-image" />
        <div className="property-content">
          <h3 className="property-title">{property.title}</h3>
          <p className="property-description">{property.description}</p>
          <div className="property-details">
            <span>{property.bedroomNumber} 🛏️</span>
            <span>{property.bathroomNumber} 🛁</span>
           
            <span>{property.propertySize} m²</span>
          </div>
          <div className="property-price">{property.price}</div>
          <button className="delete-button" onClick={() => handleDelete(property.id)}>Delete</button>
        </div>
      </div>
    ))}
  </div>

  
    
  );
};

export default Propertylist;

  